import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Contact', path: '/contact' },
  { label: 'Conditions générales', path: '/conditions-generales' },
  { label: 'Politique de confidentialité', path: '/politique-confidentialite' },
];

export default function Footer() {
  return (
    <footer className="bg-navy-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Col 1 – Branding */}
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/34e7caea-6d64-4eee-aba4-922db42b1f78.png"
              alt="KRUTAK Logo"
              className="h-9 w-auto object-contain mb-4 brightness-200"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Conseil en gestion et développement d'entreprise pour entrepreneurs et PME.
            </p>
            <p className="text-xs text-gray-500 mt-3">
              SIRET : 999 389 893 00010
            </p>
          </div>

          {/* Col 2 – Adresse */}
          <div>
            <h3 className="text-white text-xs font-semibold uppercase tracking-widest mb-5">
              Adresse
            </h3>
            <address className="not-italic text-sm text-gray-400 leading-relaxed">
              23 Rue Nationale<br />
              59800 Lille<br />
              France
            </address>
          </div>

          {/* Col 3 – Contact */}
          <div>
            <h3 className="text-white text-xs font-semibold uppercase tracking-widest mb-5">
              Contact
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+33639936329"
                  className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  +33 6 39 93 63 29
                </a>
              </li>
              <li>
                <a
                  href="mailto:mariakrutak02@inbox.eu"
                  className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  mariakrutak02@inbox.eu
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4 – Navigation */}
          <div>
            <h3 className="text-white text-xs font-semibold uppercase tracking-widest mb-5">
              Navigation
            </h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/informations-entreprise"
                  className="text-sm text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  Informations entreprise
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-navy-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} KRUTAK – Maria Ruta Krutak. Tous droits réservés.
          </p>
          <p className="text-xs text-gray-500">
            Code APE : 70.22Z – Conseil pour les affaires et autres conseils de gestion
          </p>
        </div>
      </div>
    </footer>
  );
}
